import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { Admin } from '@/types/client'

export function useAdmins() {
  return useQuery({
    queryKey: ['admins'],
    queryFn: async (): Promise<Admin[]> => {
      const { data, error } = await supabase
        .from('users')
        .select('id, full_name, email, avatar_url, role')
        .in('role', ['admin', 'super_admin'])
        .order('full_name')

      if (error) throw error

      // Add clients_count for each admin
      const adminsWithCount = await Promise.all(
        (data || []).map(async (admin) => {
          const { count } = await supabase
            .from('client_admin_assignments')
            .select('*', { count: 'exact', head: true })
            .eq('admin_id', admin.id)
            .eq('is_owner', true)

          return {
            ...admin,
            clients_count: count || 0,
          } as Admin
        })
      )

      return adminsWithCount
    },
  })
}
